// Shared helpers + inline input components for the coordinate-moderation pages.

export const asStr = (v) => (v == null ? '' : String(v));
export const inRange = (n, lo, hi) => !isNaN(n) && n >= lo && n <= hi;

// Stable per-row identity (id, falling back to name) for the edit maps.
export const rowKey = (row) => row.id ?? row.name;

// Compare current string inputs against the original row; return the changed,
// valid, non-empty fields plus a list of out-of-range field names.
export function diffCoords({ lat, lon, address }, row, { withAddress } = {}) {
  const changed = {};
  const errors = [];
  if (lat !== '' && lat !== asStr(row.lat)) {
    if (inRange(Number(lat), -90, 90)) changed.lat = Number(lat);
    else errors.push('lat');
  }
  if (lon !== '' && lon !== asStr(row.lon)) {
    if (inRange(Number(lon), -180, 180)) changed.lon = Number(lon);
    else errors.push('lon');
  }
  if (withAddress && address != null && address.trim() !== '' && address !== asStr(row.address)) {
    changed.address = address.trim();
  }
  return { changed, errors };
}

// Inline latitude/longitude input with missing (empty) + error (range) styling.
export function CoordInput({ value, onChange, disabled, lo, hi }) {
  const invalid = value !== '' && !inRange(Number(value), lo, hi);
  const missing = value === '';
  const cls = `coord-input${invalid ? ' coord-input--err' : missing ? ' coord-input--missing' : ''}`;
  return (
    <input
      type="number"
      step="any"
      className={cls}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      placeholder={`${lo}..${hi}`}
    />
  );
}

// Inline free-text input (address) with missing (empty) styling.
export function TextInput({ value, onChange, disabled, placeholder }) {
  const cls = `coord-input coord-input--wide${value.trim() === '' ? ' coord-input--missing' : ''}`;
  return (
    <input
      type="text"
      className={cls}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
    />
  );
}
